/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Billing_Board_Paid_Sub_OneInputs */



/**
* | output |
* | --- |
* | "Payment confirmed · 1 invoice" |
*
* @param {Partner_Billing_Board_Paid_Sub_OneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_board_paid_sub_one = /** @type {((inputs?: Partner_Billing_Board_Paid_Sub_OneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Board_Paid_Sub_OneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Zahlung bestätigt · 1 Rechnung")
	return /** @type {LocalizedString} */ ("Payment confirmed · 1 invoice")
});